import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { classificationRequest } from './transport';

/** Unknown/old login module maps never grant access to the new application. */
export function useClassificationAccess(attempt = 0) {
  const { authToken, userData } = useAuth();
  const identity = `${userData?.uid || userData?.id || ''}:${userData?.email || ''}:${authToken || ''}`;
  const [state, setState] = useState<{ identity: string; enabled: boolean; error?: string }>({ identity: '', enabled: false });
  useEffect(() => {
    const controller = new AbortController();
    if (!authToken) return () => controller.abort();
    classificationRequest('/access', controller.signal).then(response => response.json()).then(body => {
      if (!controller.signal.aborted) setState({ identity, enabled: body.enabled === true,
        ...(body.enabled !== true ? { error: 'Classification is not enabled for your organization.' } : {}) });
    }).catch(error => {
      if (!controller.signal.aborted) setState({ identity, enabled: false, error: error.message });
    });
    return () => controller.abort();
  }, [identity, authToken, attempt]);
  return { enabled: state.identity === identity && state.enabled,
    loading: Boolean(authToken) && state.identity !== identity,
    error: state.identity === identity ? state.error : undefined };
}
